import {
  mdiAccount,
  mdiSilverwareVariant,
  mdiPlus,
  mdiPlusCircle,
  mdiDelete,
  mdiContentSave,
  mdiContentSaveEdit,
  mdiSquareEditOutline,
  mdiClose,
  mdiTagMultipleOutline,
  mdiBookOutline,
  mdiAccountCog,
  mdiAccountGroup,
  mdiHome,
  mdiMagnify,
  mdiTranslate,
  mdiClockTimeFourOutline,
  mdiImport,
  mdiEmail,
  mdiLock,
  mdiEye,
  mdiEyeOff,
  mdiCalendarMinus,
  mdiCalendar,
  mdiDiceMultiple,
  mdiAlertCircle,
  mdiDotsVertical,
  mdiPrinter,
  mdiShareVariant,
  mdiHeart,
  mdiHeartOutline,
  mdiDotsHorizontal,
  mdiCheckboxBlankOutline,
  mdiCommentTextMultipleOutline,
  mdiDownload,
  mdiFile,
  mdiFilePdfBox,
  mdiFileImage,
  mdiCodeJson,
  mdiArrowUpDown,
  mdiCog,
  mdiSort,
  mdiOrderAlphabeticalAscending,
  mdiStar,
  mdiNewBox,
  mdiShuffleVariant,
  mdiAlert,
  mdiCheckboxMarkedCircle,
  mdiInformation,
  mdiBellAlert,
  mdiRefreshCircle,
  mdiMenu,
  mdiWeatherSunny,
  mdiWeatherNight,
  mdiLink,
  mdiRobot,
  mdiLinkVariant,
  mdiViewModule,
  mdiViewDashboard,
  mdiTools,
  mdiCalendarWeek,
  mdiCalendarToday,
  mdiCalendarMultiselect,
  mdiFormatListChecks,
  mdiLogout,
  mdiContentCopy,
  mdiClipboardCheck,
  mdiCloudUpload,
  mdiDatabase,
  mdiGithub,
  mdiFolderOutline,
  mdiApi,
  mdiTestTube,
  mdiDevTo,
  mdiBackupRestore,
  mdiNotificationClearAll,
  mdiFood,
  mdiWebhook,
  mdiFilter,
  mdiAccountPlusOutline,
  mdiDesktopTowerMonitor,
  mdiFormatColorFill,
  mdiFormSelect,
  mdiPageLayoutBody,
  mdiCalendarWeekBegin,
  mdiOpenInNew,
  mdiCheck,
  mdiBroom,
  mdiCartCheck,
  mdiArrowLeftBold,
  mdiMinus,
  mdiWindowClose,
} from "@mdi/js";

const icons = {
  // Primary
  primary: mdiSilverwareVariant,

  // General
  alert: mdiAlert,
  alertCircle: mdiAlertCircle,
  api: mdiApi,
  arrowLeftBold: mdiArrowLeftBold,
  arrowUpDown: mdiArrowUpDown,
  backupRestore: mdiBackupRestore,
  bellAlert: mdiBellAlert,
  broom: mdiBroom,
  calendar: mdiCalendar,
  calendarMinus: mdiCalendarMinus,
  calendarMultiselect: mdiCalendarMultiselect,
  calendarToday: mdiCalendarToday,
  calendarWeek: mdiCalendarWeek,
  calendarWeekBegin: mdiCalendarWeekBegin,
  cartCheck: mdiCartCheck,
  check: mdiCheck,
  checkboxBlankOutline: mdiCheckboxBlankOutline,
  checkboxMarkedCircle: mdiCheckboxMarkedCircle,
  clipboardCheck: mdiClipboardCheck,
  clockOutline: mdiClockTimeFourOutline,
  codeBraces: mdiCodeJson,
  codeJson: mdiCodeJson,
  cog: mdiCog,
  commentTextMultipleOutline: mdiCommentTextMultipleOutline,
  contentCopy: mdiContentCopy,
  database: mdiDatabase,
  desktopTowerMonitor: mdiDesktopTowerMonitor,
  devTo: mdiDevTo,
  diceMultiple: mdiDiceMultiple,
  dotsHorizontal: mdiDotsHorizontal,
  dotsVertical: mdiDotsVertical,
  download: mdiDownload,
  email: mdiEmail,
  externalLink: mdiLinkVariant,
  eye: mdiEye,
  eyeOff: mdiEyeOff,
  file: mdiFile,
  fileImage: mdiFileImage,
  filePDF: mdiFilePdfBox,
  filter: mdiFilter,
  folderOutline: mdiFolderOutline,
  food: mdiFood,
  formatColorFill: mdiFormatColorFill,
  formatListCheck: mdiFormatListChecks,
  formSelect: mdiFormSelect,
  github: mdiGithub,
  heart: mdiHeart,
  heartOutline: mdiHeartOutline,
  home: mdiHome,
  import: mdiImport,
  information: mdiInformation,
  link: mdiLink,
  lock: mdiLock,
  logout: mdiLogout,
  menu: mdiMenu,
  newBox: mdiNewBox,
  notificationClearAll: mdiNotificationClearAll,
  openInNew: mdiOpenInNew,
  orderAlphabeticalAscending: mdiOrderAlphabeticalAscending,
  pageLayoutBody: mdiPageLayoutBody,
  printer: mdiPrinter,
  refreshCircle: mdiRefreshCircle,
  robot: mdiRobot,
  search: mdiMagnify,
  shareVariant: mdiShareVariant,
  shuffleVariant: mdiShuffleVariant,
  sort: mdiSort,
  star: mdiStar,
  testTube: mdiTestTube,
  tools: mdiTools,
  translate: mdiTranslate,
  upload: mdiCloudUpload,
  viewDashboard: mdiViewDashboard,
  viewModule: mdiViewModule,
  weatherNight: mdiWeatherNight,
  weatherSunny: mdiWeatherSunny,
  webhook: mdiWebhook,
  windowClose: mdiWindowClose,

  // Crud
  createAlt: mdiPlus,
  create: mdiPlusCircle,
  delete: mdiDelete,
  save: mdiContentSave,
  update: mdiContentSaveEdit,
  edit: mdiSquareEditOutline,
  close: mdiClose,
  minus: mdiMinus,

  // Organization
  tags: mdiTagMultipleOutline,
  pages: mdiBookOutline,

  // Admin
  user: mdiAccount,
  admin: mdiAccountCog,
  group: mdiAccountGroup,
  accountPlusOutline: mdiAccountPlusOutline,
};

export const globals = {
  icons,
};
